module.exports = __webpack_public_path__ + "static/media/first_christian_church.47989a3f.mp4";